import React from 'react'
import { findDOMNode } from 'react-dom'
import numeral from 'numeral'
import _ from 'underscore'

import NumericTextBox from '../components/react-numerictextbox'

export default class MultiAllocation extends React.Component {
	constructor(props) {
		super(props)
		this.sockets = []
		this.state = {
			allocations	: props.initialAllocations || [],

			books				: [],
			tags				: [],

			is_loaded 	: false,
		}
	}

	componentDidMount() {
		// get a list of books to populate the allocations dropdown
		api('/fund', {
			method: 'GET'
		})
		.then((res) => {
			let allBooks = _.reduce(res, (r, next) => {
				_.each(next.books, (book) => { book.ccy = next.ccy; book.fund_id = next.fund_id; book.fund_name = next.fund_name; })
				return _.union(r, next.books)
			}, [])
			if (Array.isArray(allBooks) ==false) return

			let allocs = this.state.allocations

			// get a list of tags for allocations
			api('/fund/tag', {
				method: 'GET'
			})
			.then((res) => {
				if (Array.isArray(res) == false) return

				if (allocs.length == 0) {
					let defaultBook = _.find(allBooks, { book_name : this.props.book }) || allBooks[0]
					allocs = [{
						allocation_id: + _.now(),
						book_name		 : defaultBook.book_name,
						book_id			 : defaultBook.book_id,
						tag					 : res[0].tag,
					}]
				}

				this.setState({
					books 			: allBooks,
					tags				: res,
					allocations	: allocs,
					//selectedBook : _.find(allBooks, { book_name : this.props.book }) || allBooks[0],
					//selectedTag : _.find(res, { tag : this.props.tag }) ||  res[0]
				  is_loaded : true,
				}, () => {
				})
			})
		})
  }

	componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close()
    }
    delete this.sockets
	}

	getAllocations() {
		return this.state.allocations
	}

  render() {
		if (! this.state.is_loaded) {
				return <div>loading...</div>
		}

    return (
			<div>

				{
				(this.props.disabled ? undefined :
				<div ref="toolbar">
					<button className="default sm"
						  onClick={ () => {
									this.setState({allocations: this.state.allocations.concat([{
										allocation_id: + _.now(),
										book_name		 : this.state.books[0].book_name,
										book_id			 : this.state.books[0].book_id,
										tag			 	   :  this.state.tags[0].tag,
									}])})
							 } }
							style={{width:'9em',padding:'.5em .1em',marginRight: '0.3em'}}
							disabled={ this.props.disabled }>
							+ Add Allocation
					</button>
				</div>
				)
				}

				{
				(this.props.disabled ? undefined :
				<div style={{display:'block',marginTop:'5px',marginBottom:'5px',borderTop:'solid 1px rgba(0, 0, 0, 0.1)' }}/>
			  )}

				<div ref="alloations">
					{ _.map(this.state.allocations, (alloc, i) => {
						    const {books, tags} = this.state
								alloc.ratio = alloc.quantity / (this.props.totalQuantity || _.reduce(this.state.allocations, (a,b) => (a + b.quantity), 0))
								return <MultiAllocationItem key={ alloc.allocation_id } showCaption={i == 0}
																						initialValue={alloc}
																						onChange={(n) => { alloc.quantity = n; this.forceUpdate(); }}
																						onChangeBook={(n) => { alloc.book_name = n.book_name; alloc.book_id = n.book_id; this.forceUpdate(); }}
																						onChangeTag={(n) => { alloc.tag = n.tag; this.forceUpdate(); }}
																						onDelete={ () => {
																							let idx = this.state.allocations.indexOf(alloc)
																							if (idx > -1) {
																								this.state.allocations.splice(idx,1)
																								this.forceUpdate()
																							}
																						}}
																						instrument={this.props.instrument}
																						disabled={this.props.disabled}
																						{...{books, tags}}/>
							})
					}
				</div>
			</div>
    )
  }

}



class MultiAllocationItem extends React.Component {
	constructor(props) {
		super(props)
		this.sockets = []
		this.state = props.initialValue
	}

	componentDidMount() {
		realtime().then( (socket) => {
			this._socket = socket
			socket.onjson = (message) => {
				if (message.op == "_queryPL") {
					let result = []
					try {
						result = JSON.parse(message.result)
					} catch(e) { console.log(e, m.data); return; }

					if (message.cid == "ALLOC_POS_LOOKUP") {
						if (result.length > 0 && result[0].position_key_id) {
							this.setState({
								position: result[0],
							})
						}
					}

					if (message.cid == "UNIT_PRICE_LOOKUP") {
						if (result.length > 0 && result[0].instrument_id) {
							this.setState({
								unit_price: result[0].unit_price,
							})
						}
					}

				}
			}

			this.sockets.push(socket)
			this.initControls()
		})
  }
	initControls() {
		let self = this

		$(this.refs.optBook).kendoDropDownList({
			dataSource: this.props.books,
			dataTextField: "book_name",
			dataValueField: "book_id",
				index: 0,
				select: function(e) {
					let book = _.find(self.props.books, { book_name : e.item.text() })
					if (book) {
						self.setState({
							book_name : book.book_name,
							fund_name : book.fund_name,
						}, () => { self.lookupPosition() })

						if (self.props.onChangeBook) { self.props.onChangeBook(book) }
					}
				},
		});
		let book = _.find(this.props.books, { book_name : this.state.book_name })
		if (book) {
			$(this.refs.optBook).data("kendoDropDownList").value(book.book_id)
			self.setState({
				book_name : book.book_name,
				fund_name : book.fund_name,
			}, () => { self.lookupPosition() })
		}

		$(this.refs.optTag).kendoDropDownList({
			dataSource: this.props.tags,
			dataTextField: "tag",
			dataValueField: "tag_id",
				index: 0,
				select: function(e) {
					let tag = _.find(self.props.tags, { tag : e.item.text() })
					if (tag) {
						self.setState({
							tag : tag.tag,
						}, () => { self.lookupPosition() })
						if (self.props.onChangeTag) { self.props.onChangeTag(tag) }
					}
				},
		});
		let tag = _.find(this.props.tags, { tag : this.state.tag })
		if (tag) {
			$(this.refs.optTag).data("kendoDropDownList").value(tag.tag_id)
		}
	}
	componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close()
    }
    delete this.sockets
	}

	lookupPosition() {
		// clear data
		if (! this.props.instrument) {
			return
		}
		this.setState({
			position: undefined,
			unit_price: undefined,
		}, () => {this._lookupPosition()})
	}
	_lookupPosition() {

		// lookup position
		this._socket.send(JSON.stringify({
				op : "_queryPL",
				cid: "ALLOC_POS_LOOKUP",
				sql : `
					SELECT
					  position_key_id,
					  current_quantity,
						market_value
					FROM position_view
					WHERE instrument_id = ${this.props.instrument.instrument_id} AND book_name = '${this.state.book_name}' AND tag = '${this.state.tag}'
					LIMIT 1`,
		}))

		this._socket.send(JSON.stringify({
				op : "_queryPL",
				cid: "UNIT_PRICE_LOOKUP",
				sql : `
					SELECT
					  instrument_id,
					  unit_price
					FROM security_view
					WHERE instrument_id = ${this.props.instrument.instrument_id}
					LIMIT 1`,
		}))
	}


  render() {
    return (
			<div className="orderbar allocation" style={{fontSize:'0.8em', marginTop:'0.5em'}}>
				{
					(this.props.disabled ? <div className="control" style={{width:21}}></div> :
						<div className="control" style={{verticalAlign:'top'}}>
								{ this.props.showCaption ? <span className="label">&nbsp;</span> : undefined }
								<button className="default sm" tabIndex={-1}
									  onClick={ () => {
											if (this.props.onDelete) { this.props.onDelete() }
										 } }
										style={{width:'1.6em',padding:'0.3em 0.2em',marginRight: '0.3em'}}
										disabled={ this.props.disabled }>
										&#8722;
								</button>
						</div>
					)
				}
				<div className="control">
						{ this.props.showCaption ? <span className="label">Book</span> : undefined }
						<select ref="optBook" style={{ width : '14em' }}></select>
						<span className="label" style={{maxWidth: '10em', whiteSpace: 'nowrap'}}>{ this.state.fund_name }</span>
				</div>
	      <div className="control" style={{verticalAlign:'top'}}>
						{ this.props.showCaption ? <span className="label">Tag</span> : undefined }
						<select ref="optTag" style={{ width : '9em' }}></select>
						<span className="label"></span>
	      </div>
				<div className="control" style={{marginLeft:'0.2em',verticalAlign:'top'}}>
						{ this.props.showCaption ? <span className="label">Quantity</span> : undefined }
						<NumericTextBox ref="txtQuantity" style={{ }} decimals={0} format='n0'
														width={ 90 }
														onChange={(newVal) => {
															if (newVal) {
																this.setState({
																	quantity : newVal,
																}, () => {
																	if (this.props.onChange) { this.props.onChange(newVal) }
																})
															}
														}}
														disabled={this.props.disabled}
														initialValue={ this.state.quantity } />
						<span className="label" style={{marginLeft:'0.5em'}}>{
							(this.state.position == undefined ? '' : 'current: '+numeral(this.state.position.current_quantity).format('0,0'))
						}</span>
				</div>
				<div className="control" style={{marginLeft:'0.2em',verticalAlign:'top'}}>
						{ this.props.showCaption ? <span className="label">Notional</span> : undefined }
						<NumericTextBox ref="txtNotional" style={{ }} decimals={0} format='#,#.'
														width={ 70 }
														onChange={(newVal) => {
															if (newVal && this.state.notional && this.state.quantity) {
																let newQty = this.state.quantity * newVal / this.state.notional
																this.setState({
																	quantity : newQty,
																}, () => {
																	if (this.props.onChange) { this.props.onChange(newQty) }
																})
															}
														}}
														disabled={true || this.props.disabled}
														initialValue={ ( this.state.unit_price ? this.state.unit_price * this.state.quantity : undefined ) }
													  spinners={false}/>
						<span className="label" style={{marginLeft:'0.5em'}}>{
							(this.state.position == undefined ? '' : numeral(this.state.position.market_value).format('0,0'))
						} { this.props.instrument.ccy }</span>
				</div>
				<div className="control" style={{marginLeft:'0.2em',verticalAlign:'top'}}>
						{ this.props.showCaption ? <span className="label">Ratio</span> : undefined }
						<NumericTextBox ref="txtRatio" style={{ }} decimals={4} format='p2'
														width={ 60 }
														initialValue={ this.props.initialValue.ratio }
														disabled={true || this.props.disabled}
														spinners={false}/>
						{/* <span className="label" style={{marginLeft:'0.5em'}}>{
							(this.state.position == undefined || this.state.quantity == undefined ? '' : numeral(this.state.quantity / this.state.position.current_quantity).format('0.00%'))
						}</span> */}
				</div>
			</div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/multi-allocation.jsx